import { html, type TemplateResult } from 'lit';
import { MarkdownDoc } from '../../data/markdownEngine';

export interface ProjectGridProps {
  projects: MarkdownDoc[];
  onOpenDoc: (doc: MarkdownDoc) => void;
}

export function renderProjectGridPresentation(props: ProjectGridProps): TemplateResult {
  const { projects, onOpenDoc } = props;

  return html`
    <div class="projects-container">
      ${projects.map(
        p => html`
          <article class="project-card">
            <div class="card-header">
              <h3>${p.title}</h3>
              <span class="date">${p.date}</span>
            </div>
            <p class="summary">${p.summary}</p>

            <div class="tags-row">
              ${p.tags.map(t => html`<span class="tag">${t}</span>`)}
            </div>

            <div class="actions">
              <button class="read-link" @click=${() => onOpenDoc(p)}>
                📄 Read Full Markdown Breakdown →
              </button>
              ${p.github
                ? html`
                    <a class="ext-link" href="${p.github}" target="_blank" rel="noopener">GitHub ↗</a>
                  `
                : ''}
            </div>
          </article>
        `
      )}
    </div>
  `;
}
